import { Briefcase } from "lucide-react";
import { STUDIO } from "@/content";
import { SITE } from "@/constants/testIds";
import { Reveal } from "./Reveal";

const EXPERIENCE = [
  "Diritto del lavoro, relazioni sindacali, societario, procedure concorsuali e recupero crediti",
  "Legale fiduciario di aziende: automotive, software house, servizi alle imprese, GDO, immobiliare, metalmeccanica",
  "Membro di Organismo di Vigilanza ex D.lgs. 231/01",
  "Consulente legale di aziende speciali ed enti",
  "Esperto in risarcimento danni da circolazione di veicoli e natanti",
];

const Photo = () => (
  <div className="relative rounded-[2rem] overflow-hidden aspect-square bg-navy-950 max-w-md mx-auto lg:max-w-none">
    <img
      src="/brand/federico-darienzo.jpg"
      alt="Avv. Federico D'Arienzo"
      data-testid="lawyer-photo"
      className="h-full w-full object-cover"
    />
    <img src="/brand/monogram-white.png" alt="" aria-hidden className="absolute right-6 top-6 w-12 opacity-80" />
  </div>
);

export const LawyerProfile = () => (
  <section id="avvocato" className="section-pad bg-navy-900 text-white relative overflow-hidden">
    <div className="container-x relative grid lg:grid-cols-12 gap-12 lg:gap-16">
      <Reveal className="lg:col-span-5">
        <Photo />
      </Reveal>
      <Reveal className="lg:col-span-7" delay={120}>
        <span className="inline-flex items-center gap-3 whitespace-nowrap rounded-full border border-white/20 px-4 py-2">
          <span className="text-xs font-bold tabular-nums text-bronze-300">03</span>
          <span className="h-3 w-px bg-white/30" />
          <span className="text-[11px] uppercase tracking-[0.22em] font-semibold text-white">L'Avvocato</span>
        </span>
        <h2 className="mt-8 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">{STUDIO.lawyer}</h2>
        <p className="mt-3 text-sm uppercase tracking-[0.24em] text-navy-200">Fondatore dello Studio · Foro di Latina</p>
        <p data-testid={SITE.lawyerBioPlaceholder} className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-navy-100">
          Avvocato d'affari, affianca imprese e persone nel diritto del lavoro, nelle relazioni sindacali, nel diritto
          societario e nel contenzioso. Diretto e raggiungibile, segue personalmente ogni pratica con un linguaggio
          chiaro e senza formalismi inutili.
        </p>
        <div data-testid="lawyer-block-esperienza" className="mt-10 rounded-3xl bg-white/[0.04] border border-white/10 p-7 md:p-9">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-bronze text-white">
              <Briefcase className="h-5 w-5" strokeWidth={1.6} />
            </span>
            <h3 className="text-lg font-semibold">Esperienza</h3>
          </div>
          <ul className="mt-6 grid sm:grid-cols-2 gap-x-8 gap-y-4">
            {EXPERIENCE.map((it) => (
              <li key={it} className="flex gap-3 text-[14.5px] leading-snug text-navy-100">
                <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-bronze-300" />
                {it}
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);
